import { formatToDate, formatDateHoursAndSeconds } from '../../../../util'
import { AuditTable } from './AuditTable'

export const InProgressTable = ({ audits, onSelectionChange, selected }) => {
  const auditsByUpdatedAt = audits.sort(sortByUpdatedAt)
  return (
    <AuditTable
      defaultSortInfo={{ name: 'updatedAt', dir: -1 }}
      storageKey='in-progress'
      data={auditsByUpdatedAt}
      onSelectionChange={onSelectionChange}
      selected={selected}
      columns={columns}
      emptyText={`No audits in progress`}
    />
  )
}

/**
 * @typedef {{
 *  internalId: string
 * }} ColumnLabels
 */

/**
 * @typedef {{
 *   labels: ColumnLabels
 * }} CreateColsParams
 */

/**
 * @param {CreateColsParams} props
 */
const columns = [
  { dataKey: 'id', defaultVisible: false },
  { label: 'Internal ID', dataKey: 'pepId', defaultWidth: 150 },
  { label: 'Key Stage', dataKey: 'keyStage', width: 120 },
  { label: 'Primary Need', dataKey: 'primaryNeed', width: 120 },
  { label: 'Setting Name', dataKey: 'settingName', defaultWidth: 150 },
  { label: 'Setting Type', dataKey: 'settingType', defaultWidth: 150 },
  {
    label: 'Assigned Date',
    dataKey: 'createdAt',
    defaultFlex: 2,
    render: ({ value }) => formatToDate(value)
  },
  {
    label: 'Deadline',
    dataKey: 'deadlineDate',
    defaultFlex: 2,
    render: ({ value }) => formatToDate(value)
  },
  {
    label: 'Last Updated',
    dataKey: 'updatedAt',
    defaultFlex: 2,
    render: ({ value }) => formatDateHoursAndSeconds(value)
  }
]

const sortByUpdatedAt = (a, z) => {
  const maybeA = a?.updatedAt
  const maybeB = z?.updatedAt
  const aIsDefined = !!maybeA
  const zIsDefined = !!maybeB
  if (!aIsDefined && !zIsDefined) return 0

  if (!aIsDefined) return 1
  if (!zIsDefined) return -1
  if (maybeA < maybeB) return 1
  if (maybeA > maybeB) return -1
  return 0
}
